export default __webpack_public_path__ + "images/custom_328c21.svg";